export default (config = {}) => ({
    shareData: {
        title: config.title ?? document.title,
        text: config.text ?? "",
        url: config.url ?? window.location.href,
    },

    canShare: false,
    copied: false,

    async init() {
        this.canShare =
            typeof navigator.share === "function" &&
            typeof navigator.canShare === "function" &&
            navigator.canShare(this.shareData);
    },

    async copyLink() {
        try {
            await navigator.clipboard.writeText(this.shareData.url);
            this.copied = true;
            setTimeout(() => (this.copied = false), 2000);
        } catch (err) {
            console.error("Copy failed:", err);
        }
    },

    async share() {
        if (!this.canShare) return;
        try {
            await navigator.share(this.shareData);
        } catch (err) {
            if (err.name !== "AbortError") {
                console.error("Share failed:", err);
            }
        }
    },
});
